import React from 'react'
import {Flex} from '/app/src/component'
import PropTypes from 'prop-types'
import cxs from 'cxs/component'

import style from './style.css'

class Button extends React.Component {
    constructor(props){
        super(props)

        let {normalSrc, hoverSrc, activeSrc} = this.props
        hoverSrc = hoverSrc? hoverSrc: normalSrc;
        activeSrc = activeSrc? activeSrc: normalSrc;
        this.state = {
            hover: false,
            active: false,
            normalSrc: normalSrc,
            hoverSrc: hoverSrc,
            activeSrc: activeSrc,
        }
        this._onMouseOver = this._onMouseOver.bind(this)
        this._onMouseOut = this._onMouseOut.bind(this)
        this._onClick = this._onClick.bind(this)
        this._getIcon = this._getIcon.bind(this)
    }

    _getIcon(){
        let iconSrc = this.state.hover? this.state.hoverSrc: this.state.normalSrc
        iconSrc = this.props.active? this.props.activeSrc: iconSrc;
        return iconSrc;
    }

    _onClick(e){
        e.stopPropagation();
        e.target.value = this.props.text
        if(this.props.onClick) this.props.onClick(e)
    }
    _onMouseOut(e){
        this.setState({hover: false})
    }
    _onMouseOver(e){
        this.setState({hover: true})
    }

    render()
    {
        const iconSrc = this._getIcon();
        let {marginRight, marginTop, marginLeft, marginBottom, text} = this.props

        return (
            <Flex
                onClick={this._onClick} onMouseOver={this._onMouseOver} onMouseOut={this._onMouseOut}
                marginRight={marginRight} marginLeft={marginLeft} marginTop={marginTop} marginBottom={marginBottom}
                className={this.props.className}
                hAlignContent='center' vAlignContent='center'
            >
                {iconSrc && <img className={style.Image} src={iconSrc} alt='icon'/>}
                {text}
            </Flex>
        );
    }
}
Button.propTypes = {
    normalSrc: PropTypes.string, // Normal button image
    hoverSrc: PropTypes.string, // When its on hover
    activeSrc: PropTypes.string, // when its active
    onClick: PropTypes.func.isRequired, // click
    size: PropTypes.string //small, medium, fit
}

const getBorder = (props) => {
    if(props.border) return '3px solid '
}
const getHeight = (props) => {
    if(props.height) return props.height
    switch(props.size){
        case 'small':
            return '30px';
        case 'fit':
            return 'fit-content';
        case 'medium':
            return '50px';
        default:
            return props.size;
    }
}
const getWidth = (props) => {
    if(props.height) return props.height
    switch(props.size){
        case 'small':
            return '30px';
        case 'fit':
            return 'fit-content';
        case 'medium':
            return '50px'
        default:
            return props.size;
    }
}
const getColor = (props) => {
    if(props.color) return props.theme.colors[props.color]
    return props.theme.colors.lightgrey
}
const getBG = (props) => props.bg? props.theme.colors[props.bg]: 'transparent'

const StyledButton = cxs(Button)(props => ({
    ...props.defaultStyle,
    border: getBorder(props),
    height: getHeight(props),
    width: getWidth(props),
    color: getColor(props),
    backgroundColor: getBG(props),
    marginRight: props.mr,
    marginLeft: props.ml,
    marginTop: props.mt,
    marginBottom: props.mb,
    ':hover': {
        color: props.theme.colors.blue
    }
}))
StyledButton.defaultProps = {
    size: 'fit',
    defaultStyle: { // only css related here, we expand it later in styled button
        borderRadius: '10px',
        overflow: 'hidden',
        whiteSpace: 'pre-wrap',
        cursor: 'pointer',
        padding: '4px 8px',
        userSelect: 'none',
    }
}

export default StyledButton



// WEBPACK FOOTER //
// ./src/component/Button/index.js